import script from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessages.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=7f5b9a86&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5b9a86"]])

export default __exports__